module.exports = __webpack_public_path__ + "img/合约发布v2.593120df.jpg";